export type MotionPermissionState = "granted" | "denied" | "prompt" | "unknown";

export type ShakeSpotlightPermissionState = {
  /**
   * Kullanıcı İzinler sekmesinden özelliği manuel olarak aktif etti mi?
   * (Requirement: izin yokken shake ile permission prompt çıkmamalı.)
   */
  userEnabled: boolean;
  /**
   * Son bilinen motion permission durumu (iOS Safari için).
   * Not: Tarayıcıdan güvenilir şekilde query edilemediği için "son bilinen" yaklaşımı kullanıyoruz.
   */
  motionPermission: MotionPermissionState;
  updatedAt: number;
  version: 1;
};

const STORAGE_KEY = "shake-spotlight-permission";

const defaultState: ShakeSpotlightPermissionState = {
  userEnabled: false,
  motionPermission: "unknown",
  updatedAt: 0,
  version: 1,
};

export function readShakeSpotlightPermissionState(): ShakeSpotlightPermissionState {
  if (typeof window === "undefined") return defaultState;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultState;
    const parsed = JSON.parse(raw) as Partial<ShakeSpotlightPermissionState>;
    return {
      userEnabled: Boolean(parsed.userEnabled),
      motionPermission: (parsed.motionPermission ??
        "unknown") as MotionPermissionState,
      updatedAt: typeof parsed.updatedAt === "number" ? parsed.updatedAt : 0,
      version: 1,
    };
  } catch {
    return defaultState;
  }
}

export function writeShakeSpotlightPermissionState(
  partial: Partial<Omit<ShakeSpotlightPermissionState, "version">>
): ShakeSpotlightPermissionState {
  if (typeof window === "undefined") return defaultState;
  const current = readShakeSpotlightPermissionState();
  const next: ShakeSpotlightPermissionState = {
    ...current,
    ...partial,
    updatedAt: Date.now(),
    version: 1,
  };
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
}
